/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageCurrentVersion = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m19 15.586 1.626-1.626 1.414 1.414L20.414 17H23v2h-2.586l1.626 1.626-1.414 1.414L19 20.414V23h-2v-2.586l-1.626 1.626-1.414-1.414L15.586 19H13v-2h2.586l-1.626-1.626 1.414-1.414L17 15.586V13h2z" />
        <path d="M20 7.586V11h-2V9h-5V4H6v16h6v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M11 17H8v-2h3zm3-4H8v-2h6zm-3-4H8V7h3z" />
      </g>
    </g>
  </Icon>
);
export { SvgPageCurrentVersion as PageCurrentVersion };
